(function ($) {
  // noConflict モード: ここから下では $ で jQuery を使用
  class BHistory {
    constructor(el,opt){
      this.el = el;
      if($("." + this.el).length > 0){
        this.event();
      }
    }
    event(){
      const sections = document.querySelectorAll(`.${this.el}`);
      if (!sections.length) return;
  
      sections.forEach((section) => {
        const wrap = section.querySelector('.b-history-wrap');
        const scrollbar = section.querySelector('.b-history-scrollbar');
        const scrollbarBtn = section.querySelector('.b-history-scrollbarbtn');
  
        if (!wrap || !scrollbar || !scrollbarBtn) return;
  
        const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
        const trackInset = 6;
        let isDragging = false;
        let dragOffsetX = 0;
  
        const getScrollMax = () => Math.max(wrap.scrollWidth - wrap.clientWidth, 0);
        const getTrackRange = () => {
          const min = trackInset;
          const max = Math.max(
            scrollbar.clientWidth - trackInset - scrollbarBtn.offsetWidth,
            min
          );
          return { min, max };
        };
  
        const syncButtonPositionByScroll = () => {
          const scrollMax = getScrollMax();
          const { min, max } = getTrackRange();
          const trackDistance = max - min;
  
          if (trackDistance <= 0 || scrollMax <= 0) {
            scrollbarBtn.style.left = `${min}px`;
            return;
          }
  
          const rate = wrap.scrollLeft / scrollMax;
          scrollbarBtn.style.left = `${min + rate * trackDistance}px`;
        };
  
        const syncScrollByButtonLeft = (left) => {
          const scrollMax = getScrollMax();
          const { min, max } = getTrackRange();
          const trackDistance = max - min;
          const safeLeft = clamp(left, min, max);
  
          scrollbarBtn.style.left = `${safeLeft}px`;
  
          if (trackDistance <= 0 || scrollMax <= 0) {
            wrap.scrollLeft = 0;
            return;
          }
  
          const rate = (safeLeft - min) / trackDistance;
          wrap.scrollLeft = rate * scrollMax;
        };
  
        const startDrag = (clientX) => {
          const btnRect = scrollbarBtn.getBoundingClientRect();
          isDragging = true;
          dragOffsetX = clientX - btnRect.left;
          document.body.style.userSelect = 'none';
        };
  
        const moveDrag = (clientX) => {
          if (!isDragging) return;
  
          const barRect = scrollbar.getBoundingClientRect();
          const nextLeft = clientX - barRect.left - dragOffsetX;
          syncScrollByButtonLeft(nextLeft);
        };
  
        const endDrag = () => {
          if (!isDragging) return;
          isDragging = false;
          document.body.style.userSelect = '';
        };
  
        const getClientX = (e) => {
          if (typeof e.clientX === 'number') return e.clientX;
          if (e.touches && e.touches[0]) return e.touches[0].clientX;
          if (e.changedTouches && e.changedTouches[0]) return e.changedTouches[0].clientX;
          return null;
        };
  
        wrap.addEventListener('scroll', syncButtonPositionByScroll, { passive: true });
  
        scrollbarBtn.addEventListener('mousedown', (e) => {
          e.preventDefault();
          startDrag(e.clientX);
        });
  
        window.addEventListener('mousemove', (e) => {
          moveDrag(e.clientX);
        });
  
        window.addEventListener('mouseup', () => {
          endDrag();
        });
  
        scrollbarBtn.addEventListener('touchstart', (e) => {
          const clientX = getClientX(e);
          if (clientX === null) return;
          e.preventDefault();
          startDrag(clientX);
        }, { passive: false });
  
        window.addEventListener('touchmove', (e) => {
          const clientX = getClientX(e);
          if (clientX === null) return;
          if (isDragging) e.preventDefault();
          moveDrag(clientX);
        }, { passive: false });
  
        window.addEventListener('touchend', () => {
          endDrag();
        });
  
        window.addEventListener('touchcancel', () => {
          endDrag();
        });
  
        scrollbar.addEventListener('click', (e) => {
          if (e.target === scrollbarBtn || scrollbarBtn.contains(e.target)) return;
          const barRect = scrollbar.getBoundingClientRect();
          const nextLeft = e.clientX - barRect.left - scrollbarBtn.offsetWidth / 2;
          syncScrollByButtonLeft(nextLeft);
        });
  
        window.addEventListener('resize', syncButtonPositionByScroll);
        syncButtonPositionByScroll();
      });
    }
  }
  
    class Loading {
    constructor(el,opt){
      this.el = el;
      if($("." + this.el).length > 0){
        this.event();
      }
    }
    event(){
  		const isMobile = window.matchMedia('(max-width: 767px)').matches;
  		const rippleSize = isMobile ? '40rem' : '64rem';
  
  		gsap.set('.js-exclamation', {
  			opacity: 0,
  		});
  		gsap.set('.js-exclamation .top', {
  			opacity: 1,
  			y: 0,
  			scaleY: 1
  		});
  	
  		gsap.set('.js-exclamation .sub', {
  			opacity: 1,
  			y: '1.6rem',
  			scale: 1
  		});
  
  		gsap.set('.js-loading-bg-2', {
  			opacity: 0
  		});
  	
  		gsap.set('.ripple', {
  			width: '2rem',
  			height: '2rem',
  			opacity: 0
  		});
  	
  		gsap.set('.js-loading-bg-3', {
  			opacity: 0
  		});
  		
  		gsap.set('.js-next-img', {
  			opacity: 0
  		});
  
  		gsap.set('.splash', {
  			xPercent: -50,
  			yPercent: -50,
  			x: 0,
  			y: 0,
  			scale: .5,
  			opacity: 0
  		});
  
  		gsap.set('.js-third-area', {
  			opacity: 0
  		});
  		
  		gsap.set('.js-object-main', {
  			opacity: 0,
  		});
  		
  		gsap.set('.js-last-area', {
  			opacity: 1
  		});
  		
  		gsap.set('.js-last-ttl', {
  			opacity: 0,
  			visibility: 'visible'
  		});
  		const tl = gsap.timeline({
  			defaults: {
  				ease: 'power2.out'
  			}
  		});
  
  		tl.to('.js-exclamation', {
  			opacity: 1,
  			ease: 'power2.out'
  		});
  		
  		// しばらく表示
  		tl.to({}, {
  			duration: .75
  		});
  			
  		tl.to('.js-exclamation .top', {
  			y: '-8rem',
  			scaleY: .85,
  			opacity: 0,
  			duration: 1.0,
  			ease: 'power2.out'
  		}, .4);
  		
  		tl.to('.js-exclamation .sub', {
  			y: '25rem',
  			duration: .8,
  			ease: 'power2.in'
  		}, .4);
  		
  		tl.to('.js-exclamation .sub', {
  			y: '8rem',
  			duration: .85,
  			ease: 'power3.out'
  		});
  
  		// 着水タイミング
  		const splashStart = 1.2;
  
  		tl.to('.js-loading-bg-2', {
  			opacity: .8,
  			duration: .55,
  			ease: 'power2.out'
  		}, splashStart);
  		
  		tl.to('.js-loading-bg-2', {
  			opacity: 1,
  			duration: 1.0,
  			ease: 'power2.out'
  		}, splashStart + .85);
  
  		// 着水後、丸も飛沫と同じ色にする
  		tl.set('.js-exclamation .sub', {
  			backgroundColor: 'rgba(255,255,255,.65)'
  		}, splashStart);
  
  		tl.to('.js-exclamation .sub', {
  			duration: 2.0,
  			ease: 'power2.out',
  			keyframes: [
  				{
  					opacity: .75,
  					scale: 1,
  					duration: .35
  				},
  				{
  					opacity: .55,
  					scale: .95,
  					duration: .55
  				},
  				{
  					opacity: 0,
  					scale: .85,
  					duration: 1.1
  				}
  			]
  		}, splashStart);
  				
  		tl.to('.ripple:nth-child(1)', {
  			width: rippleSize,
  			height: rippleSize,
  			opacity: 0,
  			duration: 2.0,
  			ease: 'power2.out',
  			keyframes: [
  				{ opacity: .75, duration: .35 },
  				{ opacity: .45, duration: .55 },
  				{ opacity: 0, duration: 1.1 }
  			]
  		}, splashStart);
  
  		tl.to('.ripple:nth-child(2)', {
  			width: rippleSize,
  			height: rippleSize,
  			opacity: 0,
  			duration: 2.0,
  			ease: 'power2.out',
  			keyframes: [
  				{ opacity: .65, duration: .35 },
  				{ opacity: .35, duration: .55 },
  				{ opacity: 0, duration: 1.1 }
  			]
  		}, splashStart + .3);
  	
  		const splashData = isMobile
  		? [
  			{ el: '.splash:nth-child(1)', x: '-18rem', y: '-8rem',  scale: 1.25, delay: 0 },
  			{ el: '.splash:nth-child(2)', x: '-12rem', y: '-10rem', scale: 1.2,  delay: .03 },
  			{ el: '.splash:nth-child(3)', x: '-6rem',  y: '-7rem',  scale: 1.1,  delay: .05 },
  			{ el: '.splash:nth-child(4)', x: '0rem',   y: '-12rem', scale: 1.25, delay: .02 },
  			{ el: '.splash:nth-child(5)', x: '6rem',   y: '-7rem',  scale: 1.1,  delay: .07 },
  			{ el: '.splash:nth-child(6)', x: '12rem',  y: '-10rem', scale: 1.2,  delay: .05 },
  			{ el: '.splash:nth-child(7)', x: '18rem',  y: '-8rem',  scale: 1.25, delay: .01 },
  			{ el: '.splash:nth-child(8)', x: '3rem',   y: '-13rem', scale: 1.15, delay: .08 }
  		]
  		: [
  			{ el: '.splash:nth-child(1)', x: '-30rem', y: '-12rem', scale: 1.25, delay: 0 },
  			{ el: '.splash:nth-child(2)', x: '-20rem', y: '-16rem', scale: 1.2,  delay: .03 },
  			{ el: '.splash:nth-child(3)', x: '-9rem',  y: '-11rem', scale: 1.1,  delay: .05 },
  			{ el: '.splash:nth-child(4)', x: '0rem',   y: '-18rem', scale: 1.25, delay: .02 },
  			{ el: '.splash:nth-child(5)', x: '9rem',   y: '-11rem', scale: 1.1,  delay: .07 },
  			{ el: '.splash:nth-child(6)', x: '20rem',  y: '-16rem', scale: 1.2,  delay: .05 },
  			{ el: '.splash:nth-child(7)', x: '30rem',  y: '-12rem', scale: 1.25, delay: .01 },
  			{ el: '.splash:nth-child(8)', x: '4rem',   y: '-20rem', scale: 1.15, delay: .08 }
  		];
  	
  		splashData.forEach((item) => {
  			tl.to(item.el, {
  				x: item.x,
  				y: item.y,
  				scale: item.scale,
  				duration: 2.0,
  				ease: 'power2.out',
  				keyframes: [
  					{
  						opacity: .75,
  						duration: .35
  					},
  					{
  						opacity: .55,
  						duration: .55
  					},
  					{
  						opacity: 0,
  						duration: 1.1
  					}
  				]
  			}, splashStart + item.delay);
  		});
  
  		const objectStart = splashStart + 1.55;
  
  		// js-object：水面位置から表示
  		tl.to('.js-third-area', {
  			opacity: 1,
  			duration: .01
  		}, objectStart);
  		
  		// オーバルを波紋の近くから、じわっと湧き出るように表示
  		// tl.fromTo('.js-object-main',
  		// 	{
  		// 		opacity: 0,
  		// 		y: '10rem',
  		// 		scaleY: 0.9,
  		// 		transformOrigin: 'center bottom'
  		// 	},
  		// 	{
  		// 		opacity: 1,
  		// 		y: '3rem',
  		// 		scaleY: 1,
  		// 		duration: 2.4,
  		// 		ease: 'power2.out'
  		// 	},
  		// 	objectStart
  		// );
  		
  		// js-object：水面位置から表示
  		tl.to('.js-third-area', {
  			opacity: 1,
  			duration: .01
  		}, objectStart);
  
  		// 親要素を必ず表示状態に戻す
  		tl.set('.js-object', {
  			opacity: 1,
  			y: 0
  		}, objectStart);
  
  		// オーバル本体の初期化
  		tl.set('.js-object-main', {
  			opacity: 0,
  			y: '10rem',
  			scaleY: 0.9,
  			transformOrigin: 'center bottom'
  		}, objectStart);
  
  		// 出現位置から止まらず、ゆっくり一定速度で上昇
  		tl.to('.js-object-main', {
  			y: '-52%',
  			scaleY: 1,
  			duration: 5.4,
  			ease: 'none'
  		}, objectStart);
  
  		// 出始めはじわっとフェードイン
  		tl.to('.js-object-main', {
  			opacity: 0.75,
  			duration: 2.4,
  			ease: 'power2.out'
  		}, objectStart);
  
  		tl.to('.js-object-main', {
  			opacity: 0,
  			duration: 2.2,
  			ease: 'power1.out'
  		}, objectStart + 1.0);
  		
  		tl.to('.js-object', {
  			opacity: 0,
  			duration: 2.2,
  			ease: 'power1.out'
  		}, objectStart + 1.0);
  
  		// オブジェクト全体も同じ速度で上昇
  		tl.to('.js-object', {
  			y: '-45%',
  			duration: 5.0,
  			ease: 'none'
  		}, objectStart);
  
  		tl.to('.js-last-ttl', {
  			opacity: 0.5,
  			duration: 0.9,
  			ease: 'power2.out'
  		}, objectStart + 1.35);
  
  		tl.to('.js-last-ttl', {
  			opacity: 1,
  			duration: 1,
  			ease: 'power2.out'
  		}, objectStart + 1.85);
  		
  		// bg-3が出る前に、文字を先に完全に消す
  		tl.to('.js-last-ttl', {
  			opacity: 0,
  			duration: 0.6,
  			ease: 'power2.out'
  		}, objectStart + 4);
  
  		tl.set('.js-last-ttl', {
  			visibility: 'hidden'
  		}, objectStart + 5);
  
  		tl.to('.js-loading-bg-3', {
  			opacity: 1,
  			duration: 1.2,
  			ease: 'power2.out'
  		}, objectStart + 4.2);
  
  		tl.to('.js-loading-bg-3', {
  			opacity: 0,
  			duration: 1.2,
  			ease: 'power2.out'
  		}, objectStart + 4.7);
  
  		tl.to('.js-next-img', {
  			opacity: 1,
  			duration: 1.2,
  			ease: 'power2.out'
  		}, objectStart + 4.7);
  
  		tl.timeScale(0.85);
    }
  }
  
    class Top {
    constructor(el,opt){
      this.el = el;
      if($("." + this.el).length > 0){
        this.event();
      }
    }
    event(){
      gsap.registerPlugin();
      // 要素取得
      const mvMask = document.querySelector('.js-mv-mask');
      const header = document.querySelector('.js-header');
      const loop = document.querySelector('.js-mv-loop');
      const mv = document.querySelector('.js-mv');
      const drawer = document.querySelector('.js-drawer');
      
      const imgs = document.querySelectorAll('.js-mv-img');
      const copies = document.querySelectorAll('.js-mv-copy');
    
  
      // =========================
      // 初期状態
      // =========================
      // gsap.set([
      //   loadingTtl,
      //   loadingImg,
      // ], { opacity: 0 });
  
      gsap.set([
        mvMask,
        imgs,
        copies
      ], { opacity: 0 });
  
      const fadeTargets = window.innerWidth >= 768
      ? [header, drawer, loop]
      : [header, drawer, loop];
    
      gsap.set(fadeTargets, {
        opacity: 0
      });
  
      // =========================
      // タイムライン
      // =========================
  
      // ローディング以外の元々のTOPアニメーション
      // ※ paused にして、ローディング完了後に再生する
      const tl = gsap.timeline({
        paused: true
      });
  
      // =========================
      // 新ローディング
      // =========================
      const isMobile = window.matchMedia('(max-width: 767px)').matches;
      const rippleSize = isMobile ? '40rem' : '64rem';
  
      gsap.set('.js-exclamation', {
        opacity: 0,
      });
  
      gsap.set('.js-exclamation .top', {
        opacity: 1,
        y: 0,
        scaleY: 1
      });
  
      gsap.set('.js-exclamation .sub', {
        opacity: 1,
        y: '1.6rem',
        scale: 1
      });
  
      gsap.set('.js-loading-bg-2', {
        opacity: 0
      });
  
      gsap.set('.ripple', {
        width: '2rem',
        height: '2rem',
        opacity: 0
      });
  
      gsap.set('.js-loading-bg-3', {
        opacity: 0
      });
  
      gsap.set('.js-next-img', {
        opacity: 0
      });
  
      gsap.set('.splash', {
        xPercent: -50,
        yPercent: -50,
        x: 0,
        y: 0,
        scale: .5,
        opacity: 0
      });
  
      gsap.set('.js-third-area', {
        opacity: 0
      });
  
      gsap.set('.js-object-main', {
        opacity: 0,
      });
  
      gsap.set('.js-last-area', {
        opacity: 1
      });
  
      gsap.set('.js-last-ttl', {
        opacity: 0,
        visibility: 'visible'
      });
  
      const loadingTl = gsap.timeline({
        defaults: {
          ease: 'power2.out'
        }
      });
  
      loadingTl.to('.js-exclamation', {
        opacity: 1,
        ease: 'power2.out'
      });
  
      // しばらく表示
      loadingTl.to({}, {
        duration: .75
      });
  
      loadingTl.to('.js-exclamation .top', {
        y: '-8rem',
        scaleY: .85,
        opacity: 0,
        duration: 1.0,
        ease: 'power2.out'
      }, .4);
  
      loadingTl.to('.js-exclamation .sub', {
        y: '25rem',
        duration: .6,
        ease: 'power2.in'
      }, .4);
      
      loadingTl.to('.js-exclamation .sub', {
        y: '8rem',
        duration: .9,
        ease: 'power3.out'
      }, 1.0);
  
      // 着水タイミング
      const splashStart = 1;
  
      loadingTl.to('.js-loading-bg-2', {
        opacity: .8,
        duration: .55,
        ease: 'power2.out'
      }, splashStart);
  
      loadingTl.to('.js-loading-bg-2', {
        opacity: 1,
        duration: 1.0,
        ease: 'power2.out'
      }, splashStart + .85);
  
      // 着水後、丸も飛沫と同じ色にする
      loadingTl.set('.js-exclamation .sub', {
        backgroundColor: 'rgba(255,255,255,.65)'
      }, splashStart);
  
      loadingTl.to('.js-exclamation .sub', {
        duration: 2.0,
        ease: 'power2.out',
        keyframes: [
          {
            opacity: .75,
            scale: 1,
            duration: .35
          },
          {
            opacity: .55,
            scale: .95,
            duration: .55
          },
          {
            opacity: 0,
            scale: .85,
            duration: .77
          }
        ]
      }, splashStart);
  
      loadingTl.to('.ripple:nth-child(1)', {
        width: rippleSize,
        height: rippleSize,
        opacity: 0,
        duration: 2.0,
        ease: 'power2.out',
        keyframes: [
          { opacity: .75, duration: .35 },
          { opacity: .45, duration: .55 },
          { opacity: 0, duration: 1.1 }
        ]
      }, splashStart);
  
      loadingTl.to('.ripple:nth-child(2)', {
        width: rippleSize,
        height: rippleSize,
        opacity: 0,
        duration: 2.0,
        ease: 'power2.out',
        keyframes: [
          { opacity: .65, duration: .35 },
          { opacity: .35, duration: .55 },
          { opacity: 0, duration: 1.1 }
        ]
      }, splashStart + .3);
  
      const splashData = isMobile
        ? [
          { el: '.splash:nth-child(1)', x: '-18rem', y: '-8rem',  scale: 1.25, delay: 0 },
          { el: '.splash:nth-child(2)', x: '-12rem', y: '-10rem', scale: 1.2,  delay: .03 },
          { el: '.splash:nth-child(3)', x: '-6rem',  y: '-7rem',  scale: 1.1,  delay: .05 },
          { el: '.splash:nth-child(4)', x: '0rem',   y: '-12rem', scale: 1.25, delay: .02 },
          { el: '.splash:nth-child(5)', x: '6rem',   y: '-7rem',  scale: 1.1,  delay: .07 },
          { el: '.splash:nth-child(6)', x: '12rem',  y: '-10rem', scale: 1.2,  delay: .05 },
          { el: '.splash:nth-child(7)', x: '18rem',  y: '-8rem',  scale: 1.25, delay: .01 },
          { el: '.splash:nth-child(8)', x: '3rem',   y: '-13rem', scale: 1.15, delay: .08 }
        ]
        : [
          { el: '.splash:nth-child(1)', x: '-30rem', y: '-12rem', scale: 1.25, delay: 0 },
          { el: '.splash:nth-child(2)', x: '-20rem', y: '-16rem', scale: 1.2,  delay: .03 },
          { el: '.splash:nth-child(3)', x: '-9rem',  y: '-11rem', scale: 1.1,  delay: .05 },
          { el: '.splash:nth-child(4)', x: '0rem',   y: '-18rem', scale: 1.25, delay: .02 },
          { el: '.splash:nth-child(5)', x: '9rem',   y: '-11rem', scale: 1.1,  delay: .07 },
          { el: '.splash:nth-child(6)', x: '20rem',  y: '-16rem', scale: 1.2,  delay: .05 },
          { el: '.splash:nth-child(7)', x: '30rem',  y: '-12rem', scale: 1.25, delay: .01 },
          { el: '.splash:nth-child(8)', x: '4rem',   y: '-20rem', scale: 1.15, delay: .08 }
        ];
  
      splashData.forEach((item) => {
        loadingTl.to(item.el, {
          x: item.x,
          y: item.y,
          scale: item.scale,
          duration: 2.0,
          ease: 'power2.out',
          keyframes: [
            {
              opacity: .75,
              duration: .35
            },
            {
              opacity: .55,
              duration: .55
            },
            {
              opacity: 0,
              duration: 1.1
            }
          ]
        }, splashStart + item.delay);
      });
  
      const objectStart = splashStart + 1.25;
  
      // js-object：水面位置から表示
      loadingTl.to('.js-third-area', {
        opacity: 1,
        duration: .01
      }, objectStart);
  
      // 親要素を必ず表示状態に戻す
      loadingTl.set('.js-object', {
        opacity: 1,
        y: 0
      }, objectStart);
  
      // オーバル本体の初期化
      loadingTl.set('.js-object-main', {
        opacity: 0,
        y: '10rem',
        scaleY: 0.9,
        transformOrigin: 'center bottom'
      }, objectStart);
  
      // 出現位置から止まらず、ゆっくり一定速度で上昇
      loadingTl.to('.js-object-main', {
        y: '-52%',
        scaleY: 1,
        duration: 5.4,
        ease: 'none'
      }, objectStart);
  
      // 出始めはじわっとフェードイン
      loadingTl.to('.js-object-main', {
        opacity: 0.75,
        duration: 2.4,
        ease: 'power2.out'
      }, objectStart);
  
      loadingTl.to('.js-object-main', {
        opacity: 0,
        duration: 2.2,
        ease: 'power1.out'
      }, objectStart + 1.0);
  
      loadingTl.to('.js-object', {
        opacity: 0,
        duration: 2.2,
        ease: 'power1.out'
      }, objectStart + 1.0);
  
      // オブジェクト全体も同じ速度で上昇
      loadingTl.to('.js-object', {
        y: '-45%',
        duration: 5.0,
        ease: 'none'
      }, objectStart);
  
      loadingTl.to('.js-last-ttl', {
        opacity: 0.5,
        duration: 0.9,
        ease: 'power2.out'
      }, objectStart + 1.35);
  
      loadingTl.to('.js-last-ttl', {
        opacity: 1,
        duration: 1,
        ease: 'power2.out'
      }, objectStart + 1.85);
  
      loadingTl.to('.js-last-ttl', {
        opacity: 0,
        duration: 0.5,
        ease: 'power2.out'
      }, objectStart + 3.3);
      
      loadingTl.set('.js-last-ttl', {
        visibility: 'hidden'
      }, objectStart + 3.9);
  
      loadingTl.to('.js-loading-bg-3', {
        opacity: 1,
        duration: 1.0,
        ease: 'power2.out'
      }, objectStart + 3.6);
      
      loadingTl.to('.js-loading-bg-3', {
        opacity: 0,
        duration: 1.0,
        ease: 'power2.out'
      }, objectStart + 4.1);
      
      loadingTl.to('.js-next-img', {
        opacity: 1,
        duration: 1.0,
        ease: 'power2.out'
      }, objectStart + 4.1);
  
      // js-next-imgの表示時間を長めに取る
      loadingTl.to({}, {
        duration: 3.6
      }, objectStart + 5.9);
  
      // p-loadingを消す前に、裏側のMV画像を先に表示しておく
      loadingTl.set('.js-mv-img[data-slide="1"]', {
        opacity: 1
      }, objectStart + 7.0);
  
      // ローディング全体を消す
      loadingTl.to('.p-loading', {
        opacity: 0,
        duration: 0.8,
        ease: 'power2.out',
        onStart: () => {
          tl.play();
        },
        onComplete: () => {
          gsap.set('.p-loading', {
            display: 'none'
          });
        }
      }, objectStart + 7.1);
      // 速度は提供コードのまま
      loadingTl.timeScale(0.85);
  
  
      // =========================
      // ここから下は元々のtop.jsのローディング後処理
      // =========================
  
      tl.to(mvMask, {
        opacity: 1,
        duration: 0.5
      });
  
      tl.to('.js-mv-copy[data-slide="1"]', {
        opacity: 1,
        duration: 0.8
      });
  
      const target = window.innerWidth >= 768
        ? [header, drawer, loop]
        : [header, drawer, loop];
  
      tl.to(target, {
        opacity: 1,
        duration: 1
      });
  
      tl.add(() => {
        if (mvLoopSwiper) {
          mvLoopSwiper.update();
  
          if (mvLoopSwiper.autoplay) {
            mvLoopSwiper.autoplay.start();
          }
        }
      });
  
      tl.to({}, { duration: 5 });
  
      tl.to('.js-mv-copy[data-slide="1"]', {
        opacity: 1,
        duration: 0.8,
        onComplete: () => {
          gsap.set('.js-mv-copy[data-slide="1"]', {
            clearProps: "opacity"
          });
        }
      });
  
      tl.add(() => {
        startSlider(1);
      });
  
      const slides = [1, 2, 3];
      let current = 0;
      let mvTimer = null;
      let isMvStopped = false;
      
      function setSlide(index) {
        current = (index + slides.length) % slides.length;
      
        const slideNum = slides[current];
      
        imgs.forEach(el => {
          el.classList.toggle(
            'is-active',
            Number(el.dataset.slide) === slideNum
          );
        });
      
        copies.forEach(el => {
          el.classList.toggle(
            'is-active',
            Number(el.dataset.slide) === slideNum
          );
        });
      
        // slide3 の時だけ mask を消す
        if (slideNum === 3) {
          gsap.to(mvMask, {
            opacity: 0,
            duration: 0.6
          });
        } else {
          gsap.to(mvMask, {
            opacity: 1,
            duration: 0.6
          });
        }
      }
      
      function clearMvTimer() {
        if (mvTimer) {
          clearInterval(mvTimer);
          mvTimer = null;
        }
      }
      
      function startMvTimer() {
        clearMvTimer();
      
        if (isMvStopped) return;
      
        mvTimer = setInterval(() => {
          setSlide(current + 1);
        }, 6000);
      }
      
      function nextMvSlide() {
        setSlide(current + 1);
        if (!isMvStopped) {
          startMvTimer();
        }
      }
      
      function prevMvSlide() {
        setSlide(current - 1);
        if (!isMvStopped) {
          startMvTimer();
        }
      }
  
      function updateMvControlIcon() {
        if (!mvStopIcon || !mvStartIcon) return;
      
        if (isMvStopped) {
          mvStopIcon.classList.remove('is-active');
          mvStartIcon.classList.add('is-active');
        } else {
          mvStopIcon.classList.add('is-active');
          mvStartIcon.classList.remove('is-active');
        }
      }
      
      function stopMvSlide() {
        isMvStopped = true;
        clearMvTimer();
        updateMvControlIcon();
      }
      
      function restartMvSlide() {
        isMvStopped = false;
        startMvTimer();
        updateMvControlIcon();
      }    
      
      function startSlider(startIndex = 0) {
        current = startIndex;
      
        // 初期の gsap.set opacity:0 が残っていると、
        // 2枚目以降に is-active を付けても表示されないため解除
        gsap.set(imgs, {
          clearProps: 'opacity'
        });
      
        gsap.set(copies, {
          clearProps: 'opacity'
        });
      
        setSlide(current);
        startMvTimer();
        updateMvControlIcon();
      }
      
      const mvPrev = document.querySelector('.js-mv-prev');
      const mvNext = document.querySelector('.js-mv-next');
      const mvStop = document.querySelector('.js-mv-stop');
      const mvStopIcon = document.querySelector('.js-mv-stop-icon');
      const mvStartIcon = document.querySelector('.js-mv-start-icon');
  
      if (mvPrev) {
        mvPrev.addEventListener('click', (e) => {
          e.preventDefault();
          prevMvSlide();
        });
      }
      
      if (mvNext) {
        mvNext.addEventListener('click', (e) => {
          e.preventDefault();
          nextMvSlide();
        });
      }
      
      if (mvStop) {
        mvStop.addEventListener('click', (e) => {
          e.preventDefault();
      
          if (isMvStopped) {
            restartMvSlide();
          } else {
            stopMvSlide();
          }
        });
      }
      
      let mvLoopSwiper = null;
  
      const swiperEl2 = document.querySelector('.js-mv-loop');
      if (swiperEl2) {
        mvLoopSwiper = new Swiper(swiperEl2, {
          loop: true,
          slidesPerView: "auto",
          spaceBetween: 0,
          speed: 9000,
          allowTouchMove: false,
          simulateTouch: false,
          freeMode: true,
          freeModeMomentum: false,
          autoplay: {
            delay: 0,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
          },
          loopAdditionalSlides: 3,
          breakpoints: {
            768: {
              slidesPerView: "auto",
              spaceBetween: 40,
              speed: 10000,
            },
          },
        });
      }
  
      let interviewSwiper = null;
  
      function initInterviewSwiper() {
        const el = document.querySelector('.js-interview-swiper');
        if (!el) return;
      
        const isSP = window.matchMedia('(max-width: 767px)').matches;
      
        if (isSP && !interviewSwiper) {
          interviewSwiper = new Swiper(el, {
            loop: false,
            slidesPerView: 1.4,
            spaceBetween: 20,
            speed: 1000,
      
            on: {
              slideChange(swiper) {
                updateIndicator(swiper);
              }
            }
          });
      
          // 初期位置
          updateIndicator(interviewSwiper);
        }
      
        if (!isSP && interviewSwiper) {
          interviewSwiper.destroy(true, true);
          interviewSwiper = null;
        }
      }
      
      function updateIndicator(swiper) {
        const current = swiper.el.querySelector('.swiper-current');
        const pagination = swiper.el.querySelector('.swiper-pagination');
        if (!current || !pagination) return;
      
        const total = swiper.slides.length;
        const index = swiper.activeIndex;
      
        const paginationWidth = pagination.offsetWidth;
        const currentWidth = paginationWidth / total;
      
        // 位置 = インデックス × 1コマ分
        const x = currentWidth * index;
      
        current.style.transform = `translateX(${x}px)`;
      }
      // 初回
      initInterviewSwiper();
      
      // リサイズ
      window.addEventListener('resize', initInterviewSwiper);
    }
  }
  
  class Accordion {
    constructor(el,opt){
      this.el = el;
      if($("." + this.el).length > 0){
        this.event();
      }
    }
    event(){
      $('.' + this.el).click(function() {
         $(this).next().slideToggle(Number($('html').data('transition')));
         $(this).toggleClass('is-active');
      })
    }
  }
    // 参考サイト
  // https://hacknote.jp/archives/15289/
  
  let cookie = {
  	/**
  	 * 取得
  	 * @param {string} cookieName 取得するCookieの名前
  	 */
  	get : function(cookieName) {
  		if (!navigator.cookieEnabled) return false;
  
  		var getCookieAllData  = document.cookie,
  		    getCookieAllDatas = getCookieAllData.split(';'),
  		    getCookieDatas    = {},
  		    cookieKeyValue    = [],
  		    cookieKey         = '',
  		    cookieValue       = '';
  
  		var hashLength = function(arr) {
  			var result = 0, key = false;
  
  			if (typeof arr !== 'object') return false;
  
  			for (key in arr) result++;
  
  			return result;
  		};
  
  		for (var i = 0, len = getCookieAllDatas.length; i < len; i++) {
  			if (getCookieAllDatas[i] && getCookieAllDatas[i] !== '') {
  				cookieKeyValue = getCookieAllDatas[i].split('=');
  				cookieKey      = cookieKeyValue[0].replace(/^\s+/, '');
  				cookieValue    = '';
  
  				if (cookieKeyValue[1]) {
  					cookieValue = decodeURIComponent(cookieKeyValue[1]);
  				}
  
  				getCookieDatas[cookieKey] = cookieValue;
  			}
  		}
  
  		if (hashLength(getCookieDatas) > 0) {
  			if (cookieName && cookieName in getCookieDatas) {
  				return getCookieDatas[cookieName];
  			} else {
  				return getCookieDatas;
  			}
  		} else {
  			return '';
  		}
  	},
  
  	/**
  	 * 設定
  	 * @param {string} cookieName 設定するCookieの名前
  	 * @param {string} value 設定する値
  	 * @param {string} domain 有効ドメイン
  	 * @param {string} path 有効パス
  	 * @param {string} expires 有効期限
  	 * @param {boolean} secure セキュアとするか
  	 * @return {boolean} 設定に成功した場合はtrue、失敗した場合はfalseを返す
  	 */
  	set : function(cookieName, value, domain, path, expires, secure) {
  		if (!navigator.cookieEnabled || !cookieName || !value) return false;
  
  		var date, dt, ts, ts_after;
  
  		var setCookieData = cookieName + '=' + encodeURIComponent(value) + ';';
  
  		if (domain) setCookieData += 'domain=' + domain + ';';
  
  		if (path) setCookieData += 'path=' + path + ';';
  
  		if (expires) {
        dt = new Date();
        ts = dt.getTime();
  
        // 1時間後
        ts_after = ts + (1000 * 60 * 60 * expires);
  
        date = new Date(ts_after);
  			setCookieData += 'expires=' + date.toGMTString() + ';';
  		}
  
  		if (secure && secure === true && location.protocol.match(/https/)) {
  			setCookieData += 'secure';
  		}
  
  		document.cookie = setCookieData;
  
  		return true;
  	},
  
  	/**
  	 * 削除
  	 * @param {string} cookieName 削除するCookieの名前
  	 * @return {boolean} 削除に成功した場合はtrue、失敗した場合はfalseを返す
  	 */
  	del : function(cookieName) {
  		if (!navigator.cookieEnabled || !cookieName) return false;
  
  		var getCookieDatas = this.get();
  
  		if (getCookieDatas[cookieName]) {
  			var setCookieData = cookieName + '=;',
  			    date          = new Date(0);
  
  			setCookieData += 'expires=' + date.toGMTString() + '';
  
  			document.cookie = setCookieData;
  
  			return true;
  		}
  
  		return false;
  	}
  };
    class Editor {
    constructor(el,opt){
      this.el = el;
      if($("." + this.el).length > 0){
        this.event();
      }
    }
    event(){
      //------- サイドナビ アンカー ---------
      let options = {
        threshold: [0],
        rootMargin: '-49.9%',
      }
      const observerEnter = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const item = entry.target;
          if(entry.intersectionRatio > 0){
            $(`.js-sideNav [href="#${$(item).attr('id')}"]`).siblings().removeClass('is-active')
            $(`.js-sideNav [href="#${$(item).attr('id')}"]`).addClass('is-active')
          } else {
            $(`.js-sideNav [href="#${$(item).attr('id')}"]`).removeClass('is-active')
          }
        })
      }, options)
  
      const anchorEl = document.querySelectorAll('[id*="anchor"]')
      anchorEl.forEach((e)=>{
        observerEnter.observe(e)
      })
  
      
      $('[id*="anchor"]').each(function() {
        let text = $(this).find('.anchorTitle').text();
        let id = $(this).attr('id');
        if(text) {
          let newElement = $(`<a href="#${id}" class="c-transition"><hr class="c-transition">${text}</a>`);
          $('.js-sideNav').append(newElement);
        }
      })
  
      $(".js-sideNav a").click(function() {
        setTimeout(() => {
          $(this).siblings().removeClass('is-active')
          $(this).addClass('is-active')
        }, 600)
      })
  
  
      //------- 〆サイドナビ アンカー ---------
  
      //------- 画像のheught,widthをrem化 ---------
      $('.text-editor img').each(function(index, el) {
        let width = $(el).attr('width')
        // $(el).attr('width')
        $(el).css({'width': `${width * 0.1 + 'rem'}`, 'height': `auto`})
      })
      //------- 画像のheught,widthをrem化 〆 ---------
  
      //------- アコーディオン ---------
      $('.js-editor-accordion .inner').css({'display': 'none'})
  
      $('.js-editor-accordion .trigger').on('click', function() {
        $(this).find('.trigger-icon').toggleClass('is-active')
        $(this).next().slideToggle(Number($('html').data('transition')))
      })
      //------- アコーディオン 〆 ---------
  
      //------- タブ切り替え ---------
      if($(window).innerWidth() >= '769') {
  
        //------- PCの場合 ---------
        $('.js-tab .inner > div > div:nth-of-type(n + 2)').css({'display': 'none'})
        $('.js-tab .trigger .elementor-element:nth-of-type(1)').addClass('is-active')
    
        $('.js-tab .trigger .elementor-element').on('click', function() {
          $(this).siblings().removeClass('is-active')
          $(this).addClass('is-active')
          $(this).closest('.js-tab').find('.inner-child').css({'display': 'none'})
          $(this).closest('.js-tab').find('.inner-child').eq($(this).index()).fadeIn(Number($('html').data('transition')))
        })
        //------- PCの場合 〆 ---------
  
      } else {
  
        //------- SPの場合 ---------
        $('.js-tab').each(function() {
          const _el = $(this)
          const trigger_child = _el.find('.trigger-child')
          _el.find('.inner-child').each(function(index) {
            $(this).before(trigger_child[index])
          })
        })
  
        $('<span></span>').appendTo('.trigger-child > div')
  
        $('.inner-child').css({'display': 'none'})
        $('.trigger-child').click(function() {
          $(this).find('span').toggleClass('is-active')
          $(this).next().slideToggle(Number($('html').data('transition')))
        })
        //------- SPの場合 〆 ---------
        
      }
      //------- タブ切り替え 〆 ---------
    }
  }
    class FormConvert {
    constructor(el,opt){
      this.el = el;
      if($("." + this.el).length > 0){
        this.event();
      }
    }
    event(){
      //全角から半角
      function replaceZtoH(str){
        str = str.replace(/[！-～]/g, function(s){
          return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
        });
        str = str.replace(/[-－﹣−‐⁃‑‒–—﹘―⎯⏤ーｰ─━]/g, '-');
        return str;
      }
      const el = document.querySelector('.js-convert');
      el.addEventListener('blur', () => {
        const br = el.value;
        const ar = replaceZtoH(br);
        el.value = ar;
      });
    }
  }
  
    class HeaderMenu {
    constructor(el, opt) {
      this.el = el;
      if ($("." + this.el).length > 0) {
        this.event();
      }
    }
    event() {
      var windowWidth = $(window).width();
      var windowSm = 768;
      if (windowWidth <= windowSm) {
        $('.js-h-content a').on('click', function() {
          $('html').removeClass('is-open');
          scrollBan();
        });
        $('.js-mega-trigger').on('click', function() {
          $(this).toggleClass('is-active');
          $(this).find('.js-mega-trigger-plus').toggleClass('is-active');
          $(this).next('.js-mega-content').slideToggle();
        });
      } else {
        $('.js-mega-trigger').hover(function() {
          $(this).addClass('is-active');
          $(this).next('.js-mega-content').addClass('is-active');
          $(this).find('.js-mega-trigger-plus').addClass('is-active');
        }, function() {
          $(this).removeClass('is-active'); 
          $(this).next('.js-mega-content').removeClass('is-active');
          $(this).find('.js-mega-trigger-plus').removeClass('is-active');
        });
  
        $('.js-mega-content').hover(function() {
          $(this).addClass('is-active');
          $(this).prev('.js-mega-trigger').addClass('is-active');
          $(this).prev('.js-mega-trigger').find('.js-mega-trigger-plus').addClass('is-active');
        }, function() {
          $(this).removeClass('is-active');
          $(this).prev('.js-mega-trigger').removeClass('is-active');
          $(this).prev('.js-mega-trigger').find('.js-mega-trigger-plus').removeClass('is-active');
        });
      }
      
      $(window).scroll(function () {
        if ($(window).scrollTop() > 20) {
          $('html').addClass('is-scroll');
        } else {
          if (!$('html').hasClass('is-open')) {
            $('html').removeClass('is-scroll');
          }
        }
      });
      
      $('.js-drawer').click(function () {
        $('html').toggleClass('is-open');
        scrollBan();
      });
  
      // スマホメニュー内のクリック
      $('.js-header').find('a').click(function () {
        $('html').removeClass('is-open');
        scrollBan(false);
      });
  
      let scrollTop = 0;
  
      // html固定スクロール禁止/解除（引数なし=toggle / true=lock / false=unlock）
      const scrollBan = (() => {
        const html = document.documentElement; // $('html')[0] と同じ
        let locked = false;
        let scrollTop = 0;
  
        const lock = () => {
          if (locked) return;
          locked = true;
  
          scrollTop = window.scrollY || 0;
  
          // 現在位置を固定
          html.style.top = `${-scrollTop}px`;
          html.classList.add("is-hidden");
        };
  
        const unlock = () => {
          if (!locked && !html.classList.contains("is-hidden")) return;
          locked = false;
  
          // scroll-behavior を一時的に auto にして瞬間復帰
          const prevScrollBehavior = html.style.scrollBehavior;
          html.style.scrollBehavior = "auto";
  
          html.style.top = "";
          html.classList.remove("is-hidden");
  
          window.scrollTo(0, scrollTop);
  
          // 次フレームで元に戻す（0ms setTimeout より安全）
          requestAnimationFrame(() => {
            html.style.scrollBehavior = prevScrollBehavior;
          });
        };
  
        // state: true=lock / false=unlock / undefined=toggle
        return (state) => {
          if (typeof state === "boolean") {
            state ? lock() : unlock();
            return locked;
          }
          locked ? unlock() : lock();
          return locked;
        };
      })();
  
      if ($(".js-recruit-swiper").length > 0) {
        const recruitSwiper = new Swiper(".js-recruit-swiper", {
          slidesPerView: 'auto',
          spaceBetween: 6,
          speed: 30000,
          allowTouchMove: false,
          autoplay: {
            delay: 0,
          },
          loop: true,
          breakpoints: {
            768: {
              spaceBetween: 12,
            }
          },
        });
      }
  
      const swiperEl = document.querySelector('.js-swiper-loop');
      if (swiperEl) {
        const swiper = new Swiper(swiperEl, {
          loop: true,
          slidesPerView: 1.5,
          spaceBetween: 12,
          speed: 6000,
          allowTouchMove: false,
          autoplay: {
            delay: 0,
            disableOnInteraction: false,
          },
          breakpoints: {
            768: {
              slidesPerView: 2.6,
              spaceBetween: 24,
              speed: 10000,
            },
          },
        });
      }
    }
  }
    // ------------------------------------------
  // imgタグに「js-parallax」クラス、そのimgタグに要素をラップしてheightを指定すると、画像がはみ出た分が動く
  // 「data-scrub」属性に数字を入れると、動きの滑らかさが変わる
  // ------------------------------------------
  class ImgParallax {
    constructor(el,opt){
      this.el = el;
      if($("." + this.el).length > 0){
        this.event();
      }
    }
    event(){
      let cls = this.el;
      let para_ele = document.querySelectorAll("." + this.el);
      para_ele.forEach((ele, index)=> {
        let property,scrub;
  
        $(ele).css({
          'object-fit':'cover',
          'object-position':'50% 0%',
          'width':'100%',
          'height':'100%',
        })
  
        property = '50% 100%';
        scrub = $(ele).data('scrub') ? $(ele).data('scrub') : 3;
  
        ele.classList.add(cls + index);
        gsap.to('.' + cls + index, {
          objectPosition: property,
          scrollTrigger: {
            trigger: '.' + cls + index, // 要素がビューポートに入ったときにアニメーション開始
            start: 'top bottom',
            end: 'bottom top',
            scrub: scrub,
            merker: true,
          }
        })
      })
    }
  }
  
    class InviewEvent {
    constructor(el, opt){
      this.el = "." + el;
      this.all = this.el + '-all';
      this.eachUp = this.el + '-each';
      this.eachItem = this.el + '-eachItem';
      this.eachItemFast = this.el + '-eachItem-fast';
      this.eachItemDelay = this.el + '-eachItem-delay';
      if($(this.el).length > 0){
        this.event();
      }
    }
    event() {
      let options = {
        threshold: [0, 0.05, 0.1, 1]
      }
      let optionsAll = {
        threshold: [0, 0.9, 1]
      }
      const observerEnter = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const item = entry.target;
          if(entry.intersectionRatio >= 0.05){
            item.classList.add('is-inview');
            if(item.classList.contains('js-inview-each')){
              this.inviewEachUp(item);
            }
            if(item.classList.contains('js-inview-lottie')){
              this.inviewLottie(item);
            }
            observerEnter.unobserve(item);
          }
        });
      }, options);
      const observerAll = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const item = entry.target;
          if(entry.intersectionRatio >= 0.9){
            item.classList.add('is-inview');
            if(item.classList.contains('js-inview-each')){
              this.inviewEachUp(item);
            }
            observerAll.unobserve(item);
          } else {
            item.classList.remove('is-inview');
          }
        });
      }, optionsAll);
      const inviewItem = document.querySelectorAll(this.el);
      const inviewAllItem = document.querySelectorAll(this.all);
      inviewItem.forEach((e)=>{
        observerEnter.observe(e);
      });
      inviewAllItem.forEach((e)=>{
        observerAll.observe(e);
      });
    }
    inviewEachUp(item){
      $(item).find(this.eachItem).each((i,el)=>{
        gsap.to($(el), {
          // duration: 0.8,
          // alpha: 1,
          delay: (0.2 * i),
          // y: 0,
          // x: 0,
          onComplete: ()=>{
            $(el).addClass('is-inview');
          }
        });
      });
      $(item).find(this.eachItemFast).each((i,el)=>{
        gsap.to($(el), {
          // duration: 0.8,
          // alpha: 1,
          delay: (0.1 * i),
          // y: 0,
          // x: 0,
          onComplete: ()=>{
            $(el).addClass('is-inview');
          }
        });
      });
      $(item).find(this.eachItemDelay).each((i,el)=>{
        gsap.to($(el), {
          // duration: 0.8,
          // alpha: 1,
          delay: (0.5 * i),
          // y: 0,
          // x: 0,
          onComplete: ()=>{
            $(el).addClass('is-inview');
          }
        });
      });
    }
    inviewLottie(item){
      if($(item).hasClass('js-lottie-flow')) {
        lottie.flow();
      }
      if($(item).hasClass('js-lottie-no01')) {
        lottie.no01();
      }
      if($(item).hasClass('js-lottie-no02')) {
        lottie.no02();
      }
      if($(item).hasClass('js-lottie-no03')) {
        lottie.no03();
      }
      if($(item).hasClass('js-lottie-no04')) {
        lottie.no04();
      }
      if($(item).hasClass('js-lottie-no05')) {
        lottie.no05();
      }
      if($(item).hasClass('js-lottie-no06')) {
        lottie.no06();
      }
      if($(item).hasClass('js-lottie-no07')) {
        lottie.no07();
      }
    }
  }
  
    class Modal {
    constructor(el,opt){
      this.el = el;
      this.event();
      if($("." + this.el).length > 0){
        this.event();
      }
    }
    event(){
      $("." + this.el).on('click', function(e) {
        e.preventDefault();
        $(`[data-id='${$(this).attr('id')}']`).addClass('is-active');
        scrollBanOpen();
      })
  
      $("." + this.el + "-close").on('click', function() {
        $('.js-modal-container').removeClass('is-active');
        scrollBanClase();
      })
    }
  }
    // -------------------------------------------------
  // スクロール禁止
  // -------------------------------------------------
  let scrollTop = 0;
  
  function scrollBan() {
    const body = $('html')[0];
    // スクロール禁止
    if(body.classList.contains('is-hidden')){
      body.classList.remove('is-hidden');
      window.scrollTo(0, scrollTop);
      $('html').css({'scroll-behavior': 'smooth'})
    } else {
      scrollTop = window.scrollY;
      body.style.top = (scrollTop * -1) + 'px';
      body.classList.add('is-hidden');
      $('html').css({'scroll-behavior': 'inherit'})
    }
  }
    class TopElementor {
    constructor(el,opt){
      this.el = el;
      if($("." + this.el).length > 0){
        this.event();
      }
    }
    event(){
      $('.js-elementor-drawer-trigger').on('click', function(){
        $('html').toggleClass('is-elementor-drawer-open');
        scrollBan();
      });
  
      let scrollTimer;
      $(window).on('scroll', function() {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function() {
          if($(window).scrollTop() > 100) {
            $('html').addClass('is-scroll');
          } else {
            $('html').removeClass('is-scroll');
          }
        }, 100);
      });
  
    }
  }
  

  // ページ読み込みが完了したら100%に設定し、しばらく後にバーを消す
  window.addEventListener('load', () => {
    setTimeout(() => {
      $('.js-loading').fadeOut();
    }, 1500);
  });

  (() => {

    let imgParallax = new ImgParallax('js-parallax');
    let inviewEvent = new InviewEvent('js-inview');
    let headerMenu = new HeaderMenu('js-header');
    
    // ------------------------------
    // トップページ用
    // ------------------------------
    let top = new Top('p-top');
    // let loading = new Loading('p-loading');
    let bHistory = new BHistory('b-history');
    
    // ------------------------------
    // ページビルダー用
    // ------------------------------
    let topElementor = new TopElementor('js-topElementor');
    let modal = new Modal('js-modal');
    let accordion = new Accordion('js-accordion');
    let editor = new Editor('c-content');

  })();

  //DOMContentLoaded
  $(() => {
  });

  //images resources loaded
  $(window).on('load', () => {

    $(window).trigger('loading');
  });

  //after loading animation
  $(window).on('loading', () => {
  });
})(jQuery);